import { TblColorsVM } from './../../Model/cost-calculation/MakeSectorsOrder/TblProductsVM';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { TranslatePipe } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import * as arabicStrings from '@flowdegree/arabic-strings';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { DtoInvoiceToPdf } from '../../Model/cost-calculation/MakeSectorsOrder/DtoInvoiceToPdf';
import { DtoInvoiceDetailsVM } from '../../Model/orders/DtoInvoiceDetailsVM';
import { UserType } from '../Enums/UserType';
import { environment } from '../../../environments/environment';
import { cairoRegularBase64 } from '../../../assets/fonts/cairoRegularBase64.ts';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  options: any;
  currentUser: any;
  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private translate: TranslatePipe
  ) {
    this.options = {
      headers: new HttpHeaders({
        // "Content-Type": "application/json",
        // "Authorization": `Bearer ${this.auth.getToken()}`
      }),
    };
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
  }

  GetOptionsForDownLoad() {
    let optionsDownLoad: any = {
      headers: new HttpHeaders({
        // "Content-Type": "application/json",
        // "Authorization": `Bearer ${this.auth.getToken()}`
      }),
      responseType: 'blob',
    };

    return optionsDownLoad;
  }

  getFromTranslateService(key: any): string {
    let value = this.translate.transform(key);
    return value;
  }

  groupBy<T>(arr: T[], fn: (item: T) => any) {
    return arr.reduce<Record<string, T[]>>((prev, curr) => {
      const groupKey = fn(curr);
      const group = prev[groupKey] || [];
      group.push(curr);
      return { ...prev, [groupKey]: group };
    }, {});
  }

  CalcPriceByDiscount(pricePerOne?: number, discount?: number): number {
    if (pricePerOne != null && discount != null) {
      if (discount != 0) {
        return pricePerOne - pricePerOne / discount;
      }

      return pricePerOne;
    }

    return 0;
  }

  ClacNumberOfMeters(Width?: number, height?: number) {
    return (Width ?? 1) * (height ?? 1);
  }

  ClacArea(width?: any, height?: any): number {
    return (width ?? 1) * (height ?? 1);
  }

  ClacTotalCost(totalPrice?: number, count?: number) {
    count = count ?? 1;
    let TotalCost = totalPrice! * count!;
    return TotalCost;
  }

  downloadFile(byte: any, fileName: string) {
    var file = new Blob([byte], { type: 'application/pdf' });
    saveAs(file, fileName + '.pdf');
  }

  exportPDF(data: any) {
    const doc = new jsPDF();
    let user = JSON.parse(this.currentUser || '{}');
    console.log(user);

    // إضافة الخط العربي Cairo
    doc.addFileToVFS('Cairo-Regular.ttf', cairoRegularBase64);
    doc.addFont('Cairo-Regular.ttf', 'Cairo', 'normal');
    doc.setFont('Cairo');

    // بيانات الجدول
    const header = ['الاجمالي', 'الكمية', 'السعر', 'اللون', 'المنتج', '#'];
    const rows = [];
    let GTotalingredients = 0;
    let GTotalaccessories = 0;
    let indxe = 1;
    for (let i = 0; i < data.ingredientsInfo.length; i++) {
      GTotalingredients +=
        data.ingredientsInfo[i].product.pricePerOne *
        data.ingredientsInfo[i].numRollsUsed;

      rows.push([
        `${(
          data.ingredientsInfo[i].product.pricePerOne *
          data.ingredientsInfo[i].numRollsUsed
        ).toFixed(2)} ج.م`,
        ` ${data.ingredientsInfo[i].numRollsUsed} عود`,
        `${data.ingredientsInfo[i].product.pricePerOne.toFixed(2)} ج.م`,
        `${data.ingredientsInfo[i].product.tblColors.colorName}`,
        `${
 data.ingredientsInfo[i].product.tblProductName.name
        }`,
        `${indxe}`,
      ]);
      indxe++;
    }

    for (let i = 0; i < data.accessoriesInfo.length; i++) {
      GTotalaccessories +=
        data.accessoriesInfo[i].product.pricePerOne *
        data.accessoriesInfo[i].count;
      rows.push([
        `${(
          data.accessoriesInfo[i].product.pricePerOne *
          data.accessoriesInfo[i].count
        ).toFixed(2)} ج.م`,
        `${data.accessoriesInfo[i].count}`,
        `${data.accessoriesInfo[i].product.pricePerOne.toFixed(2)} ج.م`,
        `${data.accessoriesInfo[i].product.tblColors.colorName}`,
        `${
          data.accessoriesInfo[i].product.name === null
            ? data.accessoriesInfo[i].product.tblProductName.name
            : data.accessoriesInfo[i].product.name
        }`,
        `${indxe}`,
      ]);
      indxe++;
    }

    // ====== الهيدر ======
    doc.setFillColor(243, 111, 33); // أورنج
    doc.rect(0, 35, 210, 10, 'F');

    doc.setFillColor(255, 255, 255);
    doc.rect(85, 35, 40, 10, 'F');

    doc.setFontSize(40);
    // doc.addImage(`${environment.ImgUrl}/${user.userLogo}`, 170, 5, 25, 25);
    doc.addImage(
      'assets/images/Treg-Logo.png',
      170,
      5,
      25,
      25
    );
    doc.text('Trag', 14, 23);

    doc.setFontSize(22);
    doc.setTextColor(0, 0, 0);
    doc.text('بیانات الطلبیة', 105, 42, { align: 'center' });

    // ====== بيانات الفاتورة ======
    doc.setFontSize(12);
    let startY = 55;
    doc.text(`التاريخ: ${new Date().toLocaleDateString()}`, 195, startY, {
      align: 'right',
    });
    doc.text(`العميل: ${user.name} `, 195, startY + 6, {
      align: 'right',
    });
    doc.text(`الهاتف: ${user.phoneNumber} `, 195, startY + 12, {
      align: 'right',
    });
    doc.text(`المحافظة: العاشر من رمضان`, 80, startY + 6, {
      align: 'right',
    });
    doc.text(`العنوان: العاشر من رمضان`, 80, startY + 12, {
      align: 'right',
    });

    // ====== جدول المنتجات ======
    autoTable(doc, {
      startY: 80,
      head: [header],
      body: rows,
      styles: { font: 'Cairo', halign: 'center', fontSize: 11, cellPadding: 2 },
      headStyles: {
        fillColor: [243, 111, 33],
        textColor: 255,
        fontSize: 12,
        font: 'Cairo',
        fontStyle: 'normal',
      },
      bodyStyles: { font: 'Cairo' },
      alternateRowStyles: { fillColor: [240, 240, 240] },
      theme: 'grid',
      margin: { left: 14, right: 14, bottom: 40 },

      didDrawPage: () => {
        // --- الفوتر ---
        doc.setFontSize(10);
        doc.setFillColor(243, 111, 33);
        doc.rect(0, 280, 210, 2, 'F');
        doc.text(`${user.address ?? ''} : العنوان`, 60, 290, {
          align: 'right',
        });
        doc.text(`: الهاتف ${user.phoneNumber ?? ''} `, 120, 290, {
          align: 'right',
        });
        doc.text(`${user.email ?? ''} : البريد الإلكتروني`, 190, 290, {
          align: 'right',
        });
      },
    });
    autoTable(doc, {
      startY: (doc as any).lastAutoTable.finalY,
      styles: {
        font: 'Cairo',
        halign: 'center',
        fontSize: 11,
        cellPadding: 2,
        fillColor: [231, 162, 121],
      },
      body: [
        [
          `${GTotalaccessories.toFixed(2)} ج.م`,
          ':إجمالي الاكسوارات',
          `${GTotalingredients.toFixed(2)} ج.م`,
          ':إجمالي القطاعات',
        ],
      ],
      theme: 'grid',
      columnStyles: {
        0: { halign: 'center', cellWidth: 'auto' },
        1: { halign: 'right', cellWidth: 'auto' },
        2: { halign: 'center', cellWidth: 'auto' },
        3: { halign: 'right', cellWidth: 'auto' },
      },
    });
    let GTotal = GTotalingredients + GTotalaccessories;
    autoTable(doc, {
      startY: (doc as any).lastAutoTable.finalY,
      styles: { font: 'Cairo', halign: 'center', fontSize: 18, cellPadding: 2 },
      body: [[`${GTotal.toFixed(2)} ج.م`, ':الإجمالي الكلي']],
      theme: 'grid',
      columnStyles: {
        0: { halign: 'center', cellWidth: 'auto' },
        1: { halign: 'center', cellWidth: 'auto' },
      },
    });

    doc.save('invoice.pdf');
  }

  downloadBlobFile(file: any, fileName: string) {
    saveAs(file, fileName + '.pdf');
  }

  downloadBlobExcelFile(file: any, fileName: string) {
    saveAs(file, fileName + '.xlsx');
  }

  checkSearchVal(
    list: any[],
    OriginalList: any[],
    searchVal?: string,
    column: string = ''
  ) {
    list.slice();
    searchVal = arabicStrings.sanitize(searchVal!);
    const filtered: any[] = [];
    if (searchVal && searchVal !== '') {
      for (const selected of OriginalList) {
        if (
          selected[column]?.toLowerCase() &&
          arabicStrings
            .sanitize(selected[column]?.toLowerCase())
            .search(searchVal.toLowerCase()) !== -1
        ) {
          filtered.push(selected);
        }
      }

      if (filtered?.length > 0) {
        return filtered.slice();
      } else {
        return [];
      }
    }

    return OriginalList;
  }

  FireFormValidation(form: any) {
    form.markAsDirty();
    Object.keys(form.controls).forEach((field) => {
      const control = form.get(field);
      if (control != null) {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

  FireControlValidation(form?: any, field?: any) {
    form.markAsDirty();
    const control = form.get(field);
    if (control != null) {
      control.markAsTouched({ onlySelf: true });
    }
  }

  SendWhatsAppMessage(message: any, shareLink: boolean = false) {
    let url = '';
    //const url = `whatsapp://send?text=${encodedMessage}`;
    if (!shareLink) {
      const encodedMessage = encodeURIComponent(message);
      url = `https://wa.me/?text=${encodedMessage}`;
    } else {
      message = message.replace('blob:', '');
      url = `https://wa.me/?text=${message}`;
    }

    window.open(url, '_blank');
  }

  async ConvertUrlToFile(
    url: string,
    fileName: string,
    fileType: string
  ): Promise<File> {
    const blob = await this.http.get(url, { responseType: 'blob' }).toPromise();
    return new File([blob!], fileName, { type: fileType });
  }
}
